import { render, staticRenderFns } from "./ControllerListTab.vue?vue&type=template&id=2c0030d8&scoped=true&"
import script from "./ControllerListTab.vue?vue&type=script&lang=js&"
export * from "./ControllerListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0030d8",
  null
  
)

export default component.exports